module.exports = __webpack_public_path__ + "static/media/NA-MX5.260cf991.webp";